import { render, staticRenderFns } from "./InternalServerSetting.vue?vue&type=template&id=72a964c8&scoped=true&"
import script from "./InternalServerSetting.vue?vue&type=script&lang=ts&"
export * from "./InternalServerSetting.vue?vue&type=script&lang=ts&"
import style0 from "./InternalServerSetting.vue?vue&type=style&index=0&id=72a964c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a964c8",
  null
  
)

export default component.exports